import { useState } from 'react';
import { Accordion, Skeleton } from '@mantine/core';
import useDocumentsList from '@modules/banks/entities/document/query/useDocumentsList';
import { useTranslation } from 'react-i18next';
import BankWithDocumentsCard from '@modules/banks/presentation/v2/pages/DocumentsCenter/components/BankWithDocumentsCard';
import { Flex, Input } from '@huspy/briks-web';
import briksTheme from '@shared/briks-theme';
import { Search } from '@huspy/briks-icons';
import MainContentPageWrapper from '@components/v2/MainContentPageWrapper';

const DocumentsCenter = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const { isLoading, data } = useDocumentsList();
  const { t } = useTranslation();

  const searchRule = new RegExp(searchQuery.toLowerCase().trim(), 'g');

  return (
    <MainContentPageWrapper
      title={ t('documentCenter.title') }
      subtitle={ t('documentCenter.subtitle') }
    >
      <Flex justify='space-between' pt='6' pb='10' w='221px'>
        <Input
          placeholder={ t('documentCenter.actions.search.placeholder') }
          bg='bg-secondary'
          borderColor='border-secondary'
          backdropFilter='blur(32px);'
          iconPosition='left'
          icon={ <Search width={ 24 } height={ 24 } color='#6B7280' /> }
          w='100%'
          defaultValue={ searchQuery }
          onChange={ (event) => setSearchQuery(event.currentTarget.value) }
          spellCheck={ false }
          size='md'
          css={ { paddingLeft: '12' } }
          data-test='search-client-input'
        />
      </Flex>
      <Flex w='100%'>
        {isLoading ? (
          <Flex direction='column' gap={ 4 }>
            <Skeleton radius={ briksTheme.radius['radius-2'] } h={ 50 } />
            <Skeleton radius={ briksTheme.radius['radius-2'] } h={ 50 } />
            <Skeleton radius={ briksTheme.radius['radius-2'] } h={ 50 } />
          </Flex>
        ) : (
          <Accordion multiple w='100%'>
            {data?.filter(
              (bank) => new RegExp(searchRule).exec(bank.bank_name.toLowerCase())
            ).map((bank) => <BankWithDocumentsCard bankWithDocuments={ bank } key={ bank.bank_name } />)}
          </Accordion>
        )}
      </Flex>
    </MainContentPageWrapper>
  );
};

export default DocumentsCenter;
